import {
  typeMeta as staticTypeMeta,
  prioMeta as staticPrioMeta,
  statusMeta as staticStatusMeta,
  ISSUE_TYPES as STATIC_TYPES,
  PRIORITIES as STATIC_PRIOS,
  STATUSES as STATIC_STATUSES,
} from "./meta";
import { findType, findPriority, findStatus } from "./settings.jsx";

let _dynLists = { types: null, prios: null, statuses: null };
export function setMetaLists(lists) {
  _dynLists = { types: lists.issueTypes, prios: lists.priorities, statuses: lists.statuses };
}
export function dynType(id) {
  const list = _dynLists.types || STATIC_TYPES;
  return findType(list, id) || staticTypeMeta(id);
}
export function dynPrio(id) {
  const list = _dynLists.prios || STATIC_PRIOS;
  return findPriority(list, id) || staticPrioMeta(id);
}
export function dynStatus(id) {
  const list = _dynLists.statuses || STATIC_STATUSES;
  return findStatus(list, id) || staticStatusMeta(id);
}
